import React from 'react';
import { COLORS } from '../../constants';
import Donut from './Donut';
import StackBar from './StackBar';

export default function ConditionCard({ good, damaged, empty, total }) {
  return (
    <div style={{ flex: 1, background: COLORS.surface, border: `1px solid ${COLORS.line}`, borderRadius: 16, padding: '18px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 100, flexShrink: 0 }}>
        <Donut value={good} total={total} size={80} thickness={8} color={COLORS.orange} label="Condition" />
      </div>

      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', gap: 24, marginBottom: 12 }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: COLORS.green }}>{good}</div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4 }}>Good</div>
          </div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: COLORS.red }}>{damaged}</div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4 }}>Damaged</div>
          </div>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: COLORS.slate }}>{empty}</div>
            <div style={{ fontSize: 11, color: COLORS.muted, marginTop: 4 }}>Empty</div>
          </div>
        </div>
        <StackBar good={good} damaged={damaged} empty={empty} total={total} />
      </div>
    </div>
  );
}